import React from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import { COST_SHARE_TERMS_LINK } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/healthPlanAndPaymentInformationConstants'

import { BodyText, Size as BodyTextSize } from '../../atoms/bodyText/BodyText'
import { Link } from '../../atoms/link/Link'
import { openUrl } from '../../utils/expo-linking'
import { tID } from '../../utils/utils'

const Container = styled.View(({ theme }) => ({
  marginTop: theme.spacing['4px'],
  marginBottom: theme.spacing['24px'],
}))

export const SessionsCostEstimateDisclaimer = ({
  onPressContactCareNavigator,
}: {
  onPressContactCareNavigator: () => void
}) => {
  const { formatMessage } = useIntl()

  const disclaimerText = formatMessage(
    {
      defaultMessage:
        '*The cost estimate above is not a guarantee of coverage. For details on how your actual charges may vary based on the services received, <costShareTerms>learn more</costShareTerms>. For billing questions, <contactCareNavigator>contact your Care Navigator</contactCareNavigator>.',
      description: 'Disclaimer text for sessions cost estimate',
    },
    {
      costShareTerms: (chunks: string) => (
        <Link
          text={chunks}
          onPress={() => openUrl(COST_SHARE_TERMS_LINK)}
          underline
          size={BodyTextSize.SMALL}
          testID={tID('SessionsCostEstimateDisclaimer-costShareTerms-link')}
        />
      ),
      contactCareNavigator: (chunks: string) => (
        <Link
          text={chunks}
          onPress={onPressContactCareNavigator}
          underline
          size={BodyTextSize.SMALL}
          testID={tID('SessionsCostEstimateDisclaimer-contactCareNavigator-link')}
        />
      ),
    },
  )

  return (
    <Container>
      <BodyText text={disclaimerText} size={BodyTextSize.SMALL} />
    </Container>
  )
}
